module.exports = __webpack_public_path__ + "static/resetBoton-f8b5f06cc648b609c7af9807c4257cdb.png";